import React from "react";
import CustomPopoverMui from "../../../CustomPopoverMui/CustomPopoverMui";
import { Box, ListItemText, MenuItem } from "@material-ui/core";

const SelectPageSizePopover = (props) => {
  const { anchorEl, isPageSizeOpen, handleClose, setPageSize, pageSize } =
    props;
  const options = [25, 50, 100];

  return (
    <CustomPopoverMui
      anchorEl={anchorEl}
      handleClose={handleClose}
      open={isPageSizeOpen}
      id={isPageSizeOpen ? "simple-popover" : undefined}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          maxWidth: "280px",
          width: "100%",
          padding: "0.5rem",
        }}
      >
        {options.map((item) => (
          <MenuItem
            key={item}
            onClick={() => {
              handleClose();
              setPageSize(item);
            }}
            style={{
              backgroundColor: pageSize === item ? "#f0f5f0" : "transparent",
              borderRadius: pageSize === item ? "8px" : "0",
              padding: "2px 16px",
            }}
          >
            <ListItemText primary={item} />
          </MenuItem>
        ))}
      </Box>
    </CustomPopoverMui>
  );
};

export default SelectPageSizePopover;
